/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface CurrentStatus
 */
export interface CurrentStatus {
  /**
   *
   */
  id: number;
  /**
   *
   */
  name: string;
  /**
   *
   */
  created: Date;
  /**
   *
   */
  time?: number;
  /**
   *
   */
  paused?: boolean;
  /**
   *
   */
  readonly exitCode?: string | null;
}

/**
 * Check if a given object implements the CurrentStatus interface.
 */
export function instanceOfCurrentStatus(value: object): value is CurrentStatus {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("created" in value) || value["created"] === undefined) return false;
  return true;
}

export function CurrentStatusFromJSON(json: any): CurrentStatus {
  return CurrentStatusFromJSONTyped(json, false);
}

export function CurrentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentStatus {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    created: json["created"] == null ? json["created"] : parseDateTime(json["created"]),
    time: json["time"] == null ? undefined : json["time"],
    paused: json["paused"] == null ? undefined : json["paused"],
    exitCode:
      json["exit_code"] === undefined
        ? undefined
        : json["exit_code"] === null
        ? null
        : json["exit_code"],
  };
}

export function CurrentStatusToJSON(json: any): CurrentStatus {
  return CurrentStatusToJSONTyped(json, false);
}

export function CurrentStatusToJSONTyped(
  value?: Omit<CurrentStatus, "exitCode"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    time: value["time"],
    paused: value["paused"],
  };
}
